import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutPage.css';

const AboutPage = () => {
    const navigate = useNavigate();
    // Scroll to top when page is loaded
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-container">
            <div className="about-nav-back">
                <button onClick={() => navigate(-1)}>← Retour</button>
            </div>

            <header className="about-header">
                <h1 className="about-title">À Propos d'ArchivizAI</h1>
                <p className="about-subtitle">
                    Votre solution d'<strong>intelligence artificielle pour l'architecture</strong>, 
                    transformant vos esquisses et modèles basiques en <strong>rendus 3D photoréalistes</strong> en quelques secondes.
                </p>
            </header>

            <main className="about-content">
                <section className="about-section">
                    <h2>Notre Mission</h2>
                    <p>
                        Chez ArchivizAI, nous repoussons les limites de la <strong>création visuelle architecturale</strong>. 
                        Notre mission est de fournir aux architectes, architectes d'intérieur, urbanistes et designers, 
                        un <strong>logiciel d'IA pour le design d'intérieur</strong> et l'architecture qui libère la créativité 
                        et accélère le flux de production.
                    </p>
                    <p>
                        Nous croyons que la <strong>génération d'images architecturales</strong> ne doit plus être un goulot d'étranglement 
                        technique, mais une extension naturelle de la pensée créative du concepteur.
                    </p>
                </section>

                <section className="about-section">
                    <h2>La Révolution du Rendu Photoréaliste</h2>
                    <p>
                        Fini les heures d'attente pour obtenir des visuels de haute qualité. Avec notre technologie avancée, 
                        le <strong>rendu 3D photoréaliste instantané</strong> est désormais une réalité. 
                        Notre moteur analyse la composition géométrique de vos croquis, maquettes 2D ou volumes 3D, 
                        et y applique intelligemment textures, lumières et environnements.
                    </p>
                    <p>
                        C'est l'<strong>outil innovant pour la conception d'espaces et le rendu immobilier</strong> par excellence, 
                        vous garantissant de séduire vos clients à chaque présentation.
                    </p>
                </section>

                <section className="about-section">
                    <h2>Pourquoi Choisir ArchivizAI ?</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
                        <div>
                            <h3>Rapidité Exceptionnelle</h3>
                            <p>Des itérations visuelles en temps réel pour une <strong>visualisation 3D pour architectes</strong> sans compromis sur les délais.</p>
                        </div>
                        <div>
                            <h3>Précision et Détails</h3>
                            <p>Une compréhension profonde des volumes et des matériaux grâce aux derniers modèles d'IA générative.</p>
                        </div>
                        <div>
                            <h3>Facilité d'Utilisation</h3>
                            <p>Aucun besoin d'expertise poussée en logiciels de rendu complexe, il suffit de votre créativité.</p>
                        </div>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Nos Mots-Clés et Expertises</h2>
                    <p>En tant qu'experts dans le croisement de l'architecture et de la technologie, nos compétences couvrent l'ensemble du spectre de la visualisation moderne :</p>
                    <div className="seo-keywords-block">
                        <span className="seo-tag">Intelligence Artificielle en Architecture</span>
                        <span className="seo-tag">Rendu 3D Photoréaliste</span>
                        <span className="seo-tag">Génération d'images IA</span>
                        <span className="seo-tag">Visualisation Immobilière</span>
                        <span className="seo-tag">Archviz</span>
                        <span className="seo-tag">Design d'Intérieur Assisté</span>
                        <span className="seo-tag">Modélisation vers Image</span>
                    </div>
                </section>
            </main>

            <footer className="about-footer">
                <h2>Prêt à donner vie à vos projets ?</h2>
                <button className="about-cta" onClick={() => navigate('/inscription')}>
                    Commencer Maintenant
                </button>
            </footer>
        </div>
    );
};

export default AboutPage;
